import { useAPIContext } from "context/APIContext";
import { useKEAGraphContext } from "context/KEAGraphContext";
import { useModelingLanguageContext } from "context/ModelLanguageContext";
import { HTTPType, useNameModelModalContext } from "context/NameModelModalContext";
import { getModelId } from "helper/Helper";
import { useTranslation } from "react-i18next";
import { KeaButton } from "./KEAButton";

type Props = {};

export const SaveButton = (_props: Props) => {
  const { t } = useTranslation();
  const apiContext = useAPIContext();
  const keaGraphContext = useKEAGraphContext();
  const modelingLanguageContext = useModelingLanguageContext();
  const nameModelModalContext = useNameModelModalContext();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (nameModelModalContext.type === HTTPType.PUT) {
      nameModelModalContext.putModel(
        keaGraphContext.modelingGraph,
        nameModelModalContext.name,
        keaGraphContext.getUserInteractions(),
        apiContext.apiManager,
        getModelId(),
      );
      return;
    }

    nameModelModalContext.postModel(
      keaGraphContext.modelingGraph,
      nameModelModalContext.name,
      keaGraphContext.getUserInteractions(),
      apiContext.apiManager,
      modelingLanguageContext.modelingLanguage,
    );
  };
  return (
    <>
      <KeaButton onClick={handleClick}>{t("save")}</KeaButton>
    </>
  );
};
